import { createRouter, createWebHashHistory } from 'vue-router'
// ----平台路由----
import home from '@/router/router-item/home.js' // 首页
import tenant from '@/router/router-item/tenant.js' // 租户
import subsystem from '@/router/router-item/subsystem.js' // 子系统
import supervisoryControl from '@/router/router-item/supervisoryControl.js' // 平台监控
import terraceManage from '@/router/router-item/terraceManage.js' // 平台管理

// ----租户平台路由----
import tenantSysManagement from '@/router/router-item/tenantSysManagement.js' // 租户首页
// 平台路由
const navRouter = [
  {
    path: '/index',
    redirect: '/home',
    name: ''
  },
  home.routerObj, // 首页
  tenant.routerObj, // 租户
  subsystem.routerObj, // 子系统
  supervisoryControl.routerObj, // 平台监控
  terraceManage.routerObj // 平台管理
]
// 租户平台路由
const tenantNavRouter = tenantSysManagement.tenantSysManagement
const routes = [
  {
    path: '/',
    redirect: '/login',
    name: ''
  },
  // 入口页面
  {
    path: '/index',
    name: 'index',
    component: () => import('@/views/index.vue'),
    children: navRouter
  },
  // 租户入口页面
  {
    path: '/tenantIndex',
    name: 'tenantIndex',
    component: () => import('@/views/tenantIndex.vue'),
    children: tenantNavRouter
  },

  // 登陆页面
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/login.vue')
  },
  // 页面不存在
  {
    path: '/:catchAll(.*)',
    name: 'notFound',
    component: () => import('../views/notFound.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
